
// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

export function validatePassword (password) {
  return password.match(/^(?=.*[a-z])(?=.*[A-Z])(?!.* )(?=.*\d)(?=.*[\\\\!"#$%^&'()*+,-./:;<=>?@[\]^_{|}~])(?=.{10,})/)
}
